import { render, staticRenderFns } from "./SubmissionDiscussion.vue?vue&type=template&id=55698784"
import script from "./SubmissionDiscussion.vue?vue&type=script&lang=js"
export * from "./SubmissionDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports